import { FormEvent } from 'react';

import { UseFormReturn } from 'react-hook-form';

import { ISymbolDetail } from '@aqx-core/common/api/market';
import {
  EFillPolicy,
  EOrderExpiry,
  EOrderIndicate,
  EOrderType,
  IOrder,
  IPendingOrder
} from '@aqx-core/common/api/order';
import { IBulkClosePendingOrderParams } from '@aqx-core/common/api/trade';

import { IMixpanelPropertiesEditOrder } from '../../mixpanel/helpers/PlaceOrderHelper/type';

export enum EOrderFormTab {
  QUICK_TRADE = 'QUICK_TRADE',
  TRADE_FORM = 'TRADE_FORM',
  SPECIFICATION = 'SPECIFICATION'
}

export enum EUIOrderTypeLabel {
  LIMIT = 'LIMIT',
  MARKET = 'MARKET',
  MARKET_TO_LIMIT = 'MARKET_TO_LIMIT',
  STOP = 'STOP',
  STOP_LIMIT = 'STOP_LIMIT'
}

export enum EUIBuySellType {
  BUY,
  SELL
}

export interface IUITradeFormData {
  lotSize: string;
  fillPolicy?: EFillPolicy;
  symbol?: string;
  orderId?: string;
  orderType?: EOrderType;
  price?: string;
  tradeExpiry?: EOrderExpiry;
  indicate?: EOrderIndicate;
  stopLoss?: string;
  stopLossPoint?: string;
  takeProfit?: string;
  takeProfitPoint?: string;
  expiration?: Date;
  priceTrigger?: string;
  units?: string;
  buySell?: EUIBuySellType;
  decimal?: number;
  contractSize?: number;
  lotSizeStep?: number;
  marginRequirement?: string;
  hideMarginRequirement?: boolean;
  /**
   * Use for Centroid only
   * Applies to limit and stop orders only (i.e. not applicable to market orders)
   */
  centroidDeviation?: string;
}

export type TBaseTradeFormMethods = UseFormReturn<IUITradeFormData, unknown, IUITradeFormData>;

type TFormSubmitFunction = (event?: FormEvent<Element> | undefined) => void;

export interface ICustomLimitFormHandlerProps {
  customLimitFormMethods?: TBaseTradeFormMethods;
  customLimitSubmit?: TFormSubmitFunction;
}

export interface ICustomMarketFormHandlerProps {
  customMarketFormMethods?: TBaseTradeFormMethods;
  customMarketSubmit?: TFormSubmitFunction;
}

type TCustomLimitFormRequired = Required<ICustomLimitFormHandlerProps>;
type TCustomMarketFormRequired = Required<ICustomMarketFormHandlerProps>;
export type TRequiredFormHandlerProps = Pick<TCustomLimitFormRequired, 'customLimitFormMethods'> &
  Pick<TCustomMarketFormRequired, 'customMarketFormMethods'>;

export type TBaseFormMethodsProps = ICustomLimitFormHandlerProps & ICustomMarketFormHandlerProps;

export interface IOrderActionParams {
  formData: IUITradeFormData;
  symbolDetail?: ISymbolDetail;
  onSuccess: () => void;
  onError: (message: string) => void;
}
export interface IOneClickCloseOrderActionParams {
  positionId: string;
  onSuccess: () => void;
  onError: (message: string) => void;
}

export interface IEditOrderParams extends IOrderActionParams {
  pendingOrder: IPendingOrder;
  mixpanelProperties: IMixpanelPropertiesEditOrder;
}

export interface IEditMarketOrderParams extends IOrderActionParams {
  order: IOrder;
  mixpanelProperties: IMixpanelPropertiesEditOrder;
}

export interface IClosePendingOrderParams {
  orderId: string;
  symbol?: string;
  onSuccess: () => void;
  onError: (message: string) => void;
}

export interface IBulkClosePendingOrderFunctionParams {
  params: IBulkClosePendingOrderParams[];
  onSuccess: () => void;
  onError: (message: string) => void;
}

export type TUITradeConfirmationItemData = {
  key: keyof IUITradeFormData;
  label: () => string;
};
